import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IMatter } from '../interface/matter';
import { Entities } from '../interface/common';

interface IFetchMatterById {
  id?: string;
  relations?: string[];
  withFavoriteInformation?: boolean;
  withHasSubMatters?: boolean;
  withDefaultTransactionType?: boolean;
  withShowOnlyOwnEntries?: boolean;
  withHasLinkedTransactionTypes?: boolean;
  fields?: string[];
  skipGlobalErrorHandler?: boolean;
}

export const fetchMatterById = (params: IFetchMatterById): Promise<IMatter> => {
  const { id, skipGlobalErrorHandler, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const matterUrl = `${API_URLS.MATTERS_LIST}/${id}`;
  const url = queryString ? `${matterUrl}?${queryString}` : matterUrl;
  return get(
    url,
    {},
    {
      headers: {
        entity: Entities.MATTER,
      },
      skipGlobalErrorHandler,
    },
  );
};

export const useFetchMatterById = (params: IFetchMatterById) => {
  const query = useQuery<IMatter, Error>({
    queryKey: ['matter-details', params.id],
    queryFn: () => fetchMatterById(params),
    enabled: !!params.id,
  });

  return query;
};
